import { FilterAlt, Visibility } from "@mui/icons-material";
import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../shared/CustomButton";
import { CustomIconButton } from "../../shared/CustomIconButton";
import Search from "../../shared/Search";
import axiosInstance from "../../config/axios";

const MyWallet = () => {
  const [walletData, setWalletData] = useState("");
  const [walletId, setWalletId] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [data, setData] = useState([]);
  const [deleted, setDeleted] = useState([]);
  const superuserId = localStorage.getItem("is_superuser");

  const navigate = useNavigate();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const walletDatas = () => {
    superuserId == "true"
      ? axiosInstance
          .post(
            `api/admin/multivendor-super-admin-wallets-detail/`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setWalletData(
              response?.data?.super_admin_wallet_data?.current_balance,
            );
            // console.log("wallet DAta===>",response?.data?.super_admin_wallet_data?.current_balance)
          })
          .catch((error) => {
            console.log("", error);
          })
      : axiosInstance
          .post(
            `api/admin/multivendor-vendor-wallets-details/`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            console.log(
              "wallet data===>",
              response?.data?.vendor_wallet_deduction_history[0]?.wallet_id,
            );
            setWalletData(
              response?.data?.vendor_wallet_deduction_history[0]?.balance,
            );
            setWalletId(
              response?.data?.vendor_wallet_deduction_history[0]?.wallet_id,
            );
          })
          .catch((error) => {
            console.log("", error);
          });
  };
  useEffect(() => {
    walletDatas();
  }, []);

  const transitionData = () => {
    superuserId == "true"
      ? axiosInstance
          .post(
            `api/admin/multivendor-super-admin-wallets-points-transfer-history/`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setData(response?.data?.super_admin_wallet_data);
          })
          .catch((error) => {
            console.log("", error);
          })
      : axiosInstance
          .post(
            `api/admin/multivendor-vendor-wallets-credited-history/`,
            {},
            {
              headers: {
                Token: localStorage.getItem("Token"),
              },
            },
          )
          .then((response) => {
            setData(response?.data?.vendor_wallet_created_history);
            console.log(response?.data?.vendor_wallet_created_history);
          })
          .catch((error) => {
            console.log("", error);
          });

    //
  };

  useEffect(() => {
    transitionData();
  }, []);

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl text-black font-bold">Super Admin Wallet</p>
            <p className="text-black">View/Search My Wallet</p>
          </div>
          <div className="p-2 pt-5">
            <div className="items-center w-48 h-20 shadow-sm shadow-red-700 bg-blue-900 text-white rounded py-2">
              {superuserId == "true" ? null : (
                <div className="text-sm px-2 py-1 text-gray-300">
                  Wallet Id :{" "}
                  <span className="text-md text-white">{walletId}</span>
                </div>
              )}

              <div className="text-sm px-2 py-1 text-gray-300">
                Current Ballance :{" "}
                <span className="text-md text-white">{walletData}</span>{" "}
              </div>
              {/* <div className="py-3"></div>
            <div className="text-center py-3"></div> */}
            </div>
          </div>
        </div>
        <div className="flex flex-col !rounded bg-secondary border-secondary shadow-card shadow-zinc-600 m-2">
          <TableContainer
            component={Paper}
            // sx={{  }}
            sx={{ width: "100%", maxHeight: 440 }}
            className="!text-black !mx-auto !bg-white overflow-auto px-2"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                {superuserId == "true" ? (
                  <TableRow>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      CREDITED
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      DIDUCTION
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      VENDOR WALLET
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      VENDOR MOBILE NO.{" "}
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      DATE
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      SUBSCRIPTION NAME
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      id
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      ORDER ID
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      CREADIT
                    </TableCell>
                    <TableCell
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      className="!text-center !text-gray-800 !font-bold"
                    >
                      DATE
                    </TableCell>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {superuserId == "true" ? (
                  <>
                    {data?.map((elem) => {
                      return (
                        <TableRow>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <span className="text-green-600">+</span>
                            {elem?.credited_points}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            <span className="text-red-600">-</span>
                            {elem?.deduction_points}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem?.vendor_wallet?.wallet_id}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem.vendor_wallet?.vendor?.mobile}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {/* admin_user */}
                            {elem?.created_at?.slice(0, 10)}
                          </TableCell>

                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {/* admin_user */}
                            {
                              elem?.vendor_wallet?.selected_plan
                                ?.subscription_name
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {data?.map((elem) => {
                      return (
                        <TableRow>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem?.id}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem?.order_id}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              borderRight: "1px solid #D0D0D0",
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem?.credited_points}
                          </TableCell>
                          <TableCell
                            className="!text-center !text-[12px]"
                            style={{
                              fontFamily: "'Poppins', sans-serif",
                            }}
                          >
                            {elem?.created_at.slice(0, 10)}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </>
                )}
              </TableBody>
            </Table>
            {data?.length !== 0 ? (
              <TablePagination
                rowsPerPageOptions={[6]}
                count={data?.length}
                component="div"
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            ) : null}
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default MyWallet;
